const CSS_CLASSES = {
  ROOT: 'mdc-layout-grid',
  INNER: 'mdc-layout-grid__inner',
  CELL: 'mdc-layout-grid__cell',
  CELL_SPAN: 'mdc-layout-grid__cell--span',
  CELL_ORDER: 'mdc-layout-grid__cell--order',
  CELL_ALIGN: 'mdc-layout-grid__cell--align',
  FIXED_COLUMN_WIDTH: 'mdc-layout-grid--fixed-column-width',
  ALIGN: 'mdc-layout-grid--align',
};

const DEVICE_TYPE = {
  DESKTOP: 'desktop',
  PHONE: 'phone',
  TABLET: 'tablet',
};

export {CSS_CLASSES, DEVICE_TYPE};
